import { type FC, type ReactNode } from 'react';
import { useFragment, graphql } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { Recipients } from '../../components/NftPaymentInfo/Recipients.tsx';

import { type NftPdpSplitComponent_address$key } from './__generated__/NftPdpSplitComponent_address.graphql.ts';
import { type NftPdpSplitComponent_paymentAddresses$key } from './__generated__/NftPdpSplitComponent_paymentAddresses.graphql.ts';

import styles from './NftPdpSplitComponent.scss';

type Props = {
    singleAddress?: NftPdpSplitComponent_address$key | null | undefined;
    addressList?: NftPdpSplitComponent_paymentAddresses$key | null | undefined;
    type: 'SALE' | 'ROYALTY';
    handleViewDetailsClick: () => void;
};

export const NftPdpSplitComponent: FC<Props> = ({
    singleAddress: singleAddressRef = null,
    addressList: addressListRef = null,
    type,
    handleViewDetailsClick,
}) => {
    const singleAddress = useFragment(
        graphql`
            fragment NftPdpSplitComponent_address on EthereumAddressType {
                ...Recipients_address
            }
        `,
        singleAddressRef
    );
    const addressList = useFragment(
        graphql`
            fragment NftPdpSplitComponent_paymentAddresses on PaymentAddresses {
                ...Recipients_paymentAddresses
            }
        `,
        addressListRef
    );

    let splitLabel: ReactNode;

    if (type === 'SALE') {
        splitLabel = (
            <FormattedMessage id="nft.pdp.sidebar.splitLabel.sale" defaultMessage="Sale Split" />
        );
    } else {
        splitLabel = (
            <FormattedMessage
                id="nft.pdp.sidebar.splitLabel.royalty"
                defaultMessage="Royalty Split"
            />
        );
    }

    return (
        <div className={styles.splitSectionWrapper}>
            <Link className={styles.splitWrapper} onClick={handleViewDetailsClick}>
                <span className={styles.splitLabel}>{splitLabel}</span>
                <Recipients singleAddress={singleAddress} addressList={addressList} />
            </Link>
        </div>
    );
};
